import React from "react";

/**
 * Safe multilingual text renderer that preserves paragraph breaks written
 * in the CMS. Every line break written in the CMS (single or blank line)
 * becomes its own <p> with consistent paragraph spacing.
 *
 * No HTML is interpreted — React escapes everything, so this is safe to
 * use with user-editable multilingual fields.
 */
export function RichText({ text, className = "", gapClassName = "mt-4 md:mt-5" }) {
  if (!text) return null;
  const paragraphs = String(text)
    .replace(/\r\n?/g, "\n")
    .split(/\n+/)
    .map(s => s.trim())
    .filter(Boolean);
  return (
    <>
      {paragraphs.map((p, i) => (
        <p key={i} className={`${className} ${i > 0 ? gapClassName : ""}`.trim()}>{p}</p>
      ))}
    </>
  );
}
